import React from "react";
import { Card } from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  { name: "Low Estimate", value: 3160000 },
  { name: "ValPro", value: 4000000 },
  { name: "High Estimate", value: 5541000 },
];

const ValueEstimationChart = () => {
  return (
    <Card title="Value Estimation">
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data}>
          <XAxis dataKey="name" />
          <YAxis />
          <Tooltip formatter={(value) => `$${value.toLocaleString()}`} />
          <Legend />
          <Bar dataKey="value" fill="#97c23c" />
        </BarChart>
      </ResponsiveContainer>
    </Card>
  );
};

export default ValueEstimationChart;
